module.exports = __webpack_public_path__ + "Roboto-MediumItalic.7a49ce79b6089d4d37bf.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.eot
// module id = 115
// module chunks = 19